import { render, staticRenderFns } from "./LeaderboardTableHead.vue?vue&type=template&id=d73eccb6"
import script from "./LeaderboardTableHead.vue?vue&type=script&lang=js"
export * from "./LeaderboardTableHead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports